import { connect } from 'react-redux';

import StorePage from '../components/pages/show-stores';
import Actions from '../actions';
import BaseMenu from './base/base-menu';

const mapStateToProps = (state, ownProps) => ({
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentZone: (zoneId, page, limit) => {
        dispatch(Actions.setCurrentZone(zoneId));
        dispatch(Actions.displayLoader());
        dispatch(Actions.getStoresByZone(zoneId, page, limit)).then(() => dispatch(Actions.hideLoader()));
    },
});

const ShowStoresConnector = connect(mapStateToProps, mapDispatchToProps)(StorePage);

export default BaseMenu(ShowStoresConnector);



/** WEBPACK FOOTER **
 ** ./src/containers/show-stores-connector.js
 **/